import React from 'react';
import { NextPage } from 'next';
import EducationalCodeEthicsTemplate from '@components/EducationalCodeEthics/EducationalCodeEthics';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';

interface IEducationalCodeEthics {}

const EducationalCodeEthics: NextPage<IEducationalCodeEthics> = () => {
    const { t } = useTranslation();

    return (
        <>
            <HeaderTemplate />
            <ContentTemplate withPadding>
                <EducationalCodeEthicsTemplate />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

export default EducationalCodeEthics;
